import React, { useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/autoplay";
import { Autoplay } from "swiper/modules";
import assets from "../assets/assets";
import CountUp from "react-countup";


const ClientLogoSlider = () => {
  const swiperRef = useRef(null);

  const { walmart,
    netflix,
    invision,
    amazon,
    yahoo, } = assets();

  const clientLogos = [
    walmart,
    netflix,
    invision,
    amazon,
    yahoo,
    walmart,
    netflix,
    invision,
    amazon,
    yahoo,
  ];

  return (
    <section className="pt-0 text-center">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-xl-5 col-lg-6 mb-3">
            <span className="text-dark-gray fw-700 fs-15 text-uppercase border-bottom border-color-extra-medium-gray">
              Join the{" "}
              <CountUp start={0} end={10000} duration={5} separator="," />+ companies using our service
            </span>
          </div>
        </div>
        <div className="row position-relative mt-3">
          <div className="col">
            <Swiper
              slidesPerView={2}
              spaceBetween={0}
              speed={3000}
              loop={true}
              autoplay={{ delay: 0, disableOnInteraction: false }}
              breakpoints={{
                576: { slidesPerView: 2 },
                768: { slidesPerView: 3 },
                1200: { slidesPerView: 5 },
              }}
              modules={[Autoplay]}
              className="mySwiper"
              ref={swiperRef}
            >
              {clientLogos.map((logo, index) => (
                <SwiperSlide key={index} className="text-center">
                  <a href="#">
                    <img src={logo} alt={`Client ${index + 1}`} className="client-logo" />
                  </a>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ClientLogoSlider;
